import { FormDrawer, FormDrawerContent, RenderProps, TextField } from "@dgs/core";
import { FormikErrors } from "formik";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { AttendanceSelectField } from "../events/eventDetails/invitationList/AttendanceSelectField";
import { EventSingleSelect } from "./select/EventSelect";
import { IInvitationListAttachBulkEditContactsFormState } from "./types/invitationList";

const initialValues: IInvitationListAttachBulkEditContactsFormState = {
	event: null,
	personCount: 1,
	attendancePrediction: "will_attend",
};

const useValidate = () => {
	const { t } = useTranslation();

	return (values: IInvitationListAttachBulkEditContactsFormState) => {
		const errors: FormikErrors<IInvitationListAttachBulkEditContactsFormState> = {};

		if (!values.event) {
			errors.event = t("Required field");
		}

		if (values.personCount === null) {
			errors.personCount = t("Required field");
		}

		if (values.personCount < 0) {
			errors.personCount = t("The value has to be greater than 0");
		}

		return errors;
	};
};

interface Props extends RenderProps {
	onSubmit: (values: IInvitationListAttachBulkEditContactsFormState) => Promise<any>;
}

export const AttachContactToInvitationListDrawer: FC<Props> = ({ open, handleClose, onSubmit }) => {
	const { t } = useTranslation();
	const validate = useValidate();

	return (
		<FormDrawer
			open={open}
			onSubmit={onSubmit}
			renderForm={(props) => (
				<FormDrawerContent {...props}>
					<EventSingleSelect name="event" label={t("Event")} required />
					<TextField name="personCount" label={t("Person count")} type="number" required />
					<AttendanceSelectField required />
				</FormDrawerContent>
			)}
			initialValues={initialValues}
			onClose={handleClose}
			title={t("Add contacts to invitation list")}
			validate={validate}
		/>
	);
};
